require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 80
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/core-js/library/modules/es7.symbol.async-iterator.js